// Single source of truth for which per-tab settings persist across launches and
// under which localStorage key. The `keys` whitelist encodes the rule we want
// applied uniformly: user PREFERENCES persist; transient view/session state
// (active filters, selection, in-flight file lists, progress) is deliberately
// excluded so it resets each launch. Consumed by settingsMiddleware (save side)
// and tabSettingsThunk (load side) so the two never drift.
//
// The map key is the Redux slice name (which is also the `<slice>/<action>`
// prefix the middleware matches on).
export const PERSISTED_SLICES = {
    fixSettings: {
        storageKey: 'fixSettings',
        // Excluded (transient view state): showOnlyFixes, activeFilters, activeFileTypes.
        keys: ['backupOriginalFiles', 'fixIncompatibleFiles', 'convertAiffToWav', 'conversionFormat', 'useStatusBadges', 'listGrouping', 'listSort'],
    },
    organizerSettings: {
        storageKey: 'organizerSettings',
        keys: ['operation', 'mainOrganization', 'secondaryOrganization', 'tertiaryOrganization', 'includeMonth', 'dateFormat', 'appendToBeginning'],
    },
    fixMetadata: {
        storageKey: 'fixMetadataSettings',
        // Excluded (transient/data): files, metadataComparisons, isProcessing,
        // progress, cancelRequested, editingFile, autoAnalyze.
        keys: ['backupBeforeWrite', 'writeMode', 'beautify', 'autoFix', 'enabledFields', 'dateFormat', 'filenameMode', 'hideEditTip'],
    },
    loudnessSettings: {
        // Same key the old save-on-close path used, so existing saved values load.
        storageKey: 'loudnessSettings',
        // Excluded (transient view state): loudnessFilterMin/Max.
        keys: ['loudnessLevel', 'inputLoudnessLevel', 'addLoudnessToFileNames', 'changeLoudness', 'backupLoudnessOriginalFiles', 'listGrouping', 'listSort'],
    },
    automixSettings: {
        storageKey: 'automixSettings',
        keys: ['outDir', 'order', 'stems'],
    },
};

// Return a copy of `obj` containing only the whitelisted `keys` that are present.
export function pickPersisted(obj, keys) {
    const out = {};
    if (!obj) return out;
    for (const k of keys) if (obj[k] !== undefined) out[k] = obj[k];
    return out;
}
